// Format date helper utility
export const formatDate = (dateString, format = "MM/DD/YYYY") => {
    if (!dateString) return "";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        return "";
    }

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const hours = date.getUTCHours() + 3; // Adjust to Israel time (UTC+3)
    const minutes = date.getUTCMinutes();

    // Format hours for 12-hour format
    const hour12 = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";

    // Format numbers to have leading zeros
    const formatNum = (num) => num.toString().padStart(2, "0");

    switch (format) {
        case "MM/DD/YYYY":
            return `${formatNum(month + 1)}/${formatNum(day)}/${year}`;
        case "YYYY-MM-DD":
            return `${year}-${formatNum(month + 1)}-${formatNum(day)}`;
        case "MMMM DD, YYYY":
            return `${months[month]} ${day}, ${year}`;
        case "h:mm":
            return `${hour12}:${formatNum(minutes)}`;
        case "h:mm A":
            return `${hour12}:${formatNum(minutes)} ${ampm}`;
        case "HH:mm":
            return `${formatNum(hours)}:${formatNum(minutes)}`;
        default:
            return `${formatNum(month + 1)}/${formatNum(day)}/${year}`;
    }
};